<nav
  [ngClass]="[
    HideForEmbed ? 'navbar1' : 'navbar navbar-default whitebar',
    hideHeader ? 'navbar1' : 'null',
    geoLockTool ? 'navbar1' : 'navbar navbar-default whitebar'
  ]"
  *ngIf="
    (!hideHeader && mapService.elementsVisibility['sign_up']) ||
    mapService.elementsVisibility['log_in'] ||
    mapService.elementsVisibility['support'] ||
    mapService.elementsVisibility['news'] ||
    mapService.elementsVisibility['site_title'] ||
    mapService.elementsVisibility['site_subtitle'] ||
    mapService.elementsVisibility['map_logo']
  "
>
  <div class="whitebar container-fluid" id="whitebar">
    <div class="navbar-header">
      <button
        type="button"
        class="navbar-toggle collapsed"
        data-toggle="collapse"
        data-target="#collapsable-nav-white"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>

      <a id="map-link" href="{{ mapLogoUrl }}">
        <p class="navbar-brand" id="mapport">
          <!-- wildfireviewer logo -->
          <img
            *ngIf="mapService.elementsVisibility['map_logo']"
            class="logo-img img-responsive"
            id="logo_placeholder"
            src="{{ mapLogo }}"
          />
          <span
            id="site_title"
            class="mytooltip"
            *ngIf="mapService.elementsVisibility['site_title']"
            [innerHtml]="siteTitle | sanitizeHtml"
          ></span>
          <span
            id="site_subtitle"
            class="mytooltip"
            *ngIf="mapService.elementsVisibility['site_subtitle']"
            [innerHtml]="subTitle | sanitizeHtml"
          ></span>
        </p>
      </a>
    </div>
    <div
      class="collapse navbar-collapse"
      id="collapsable-nav-white"
      style="padding: 0px"
    >
      <ul
        id="enplan-user"
        class="nav navbar-nav whitebar-nav navbar-right"
        [ngClass]="firstName || firstName ? 'showBefore' : ''"
      >
        <li *ngIf="userLevel === '500'">
          <p class="navbar-text" id="access-level-menu">
            <!-- View : -->
            <select
              id="selected-level"
              (change)="onChangeDemigodMenu($event)"
              [(ngModel)]="subMenu"
            >
              <option value="0">Public</option>

              <option value="100">Client</option>
              <option value="200">Reader</option>
              <option value="300">Editor</option>
              <option value="400">Admin</option>
              <option value="500">Demigod</option>
            </select>
          </p>
        </li>
        <li class="username">
          <p
            class="navbar-text"
            style="font-size: 16px !important; font-weight: 500 !important"
          >
            {{ firstName }} {{ lastName }}
          </p>
        </li>
        <li *ngIf="userLevel === '500'">
          <p class="navbar-text">
            <a
              id="submit-pdf2"
              href="{{ dashUrl }}"
              (click)="goToDashboard()"
              class="navbar-link"
              >Dashboard</a
            >
          </p>
        </li>
        <li *ngIf="userLevel === '500'">
          <p class="navbar-text">
            <a
              id="submit-pdf1"
              href="{{ mapsUrl }}"
              (click)="goToMaps()"
              class="navbar-link"
              >My Maps</a
            >
          </p>
        </li>
        <li *ngIf="auth.user">
          <p class="navbar-text">
            <a (click)="myReports()" class="navbar-link"
              >My Reports

              <!-- <b class="caret"></b> -->
              <b class="up-caret" *ngIf="!showReports"></b>
              <b class="down-caret" *ngIf="showReports"></b>
            </a>
          </p>
        </li>
        <li *ngIf="auth.user">
          <p class="navbar-text">
            <a
              id="submit-pdf3"
              href="{{ accountUrl }}"
              (click)="goToAccount()"
              class="navbar-link"
              >My Account</a
            >
          </p>
        </li>

        <li *ngIf="!auth.user">
          <p class="navbar-text">
            <a href="parcelviewer/subscribe/" class="navbar-link">Subscribe</a>
          </p>
        </li>
        <li
          class="news hide-logo"
          *ngIf="mapService.elementsVisibility['news']"
        >
          <p class="navbar-text">
            <a href="{{ headerNews }}" target="_blank" class="navbar-link"
              >News</a
            >
          </p>
        </li>
        <li class="logout hide-logo">
          <p class="navbar-text">
            <a *ngIf="showLogin" (click)="logOut()" class="navbar-link"
              >Log Out</a
            >
            <a
              *ngIf="!showLogin && mapService.elementsVisibility['log_in']"
              (click)="login()"
              class="navbar-link"
              >Log In</a
            >
          </p>
        </li>

        <li class="logout show-logo">
          <p class="navbar-text">
            <a class="navbar-link"
              ><img src="/assets/img/logout.png" alt="logot-image"
            /></a>
          </p>
        </li>
        <li
          class="support hide-logo"
          *ngIf="mapService.elementsVisibility['support']"
        >
          <p class="navbar-text">
            <a
              id="support_a"
              href="{{ headerSupport }}"
              target="_blank"
              class="navbar-link"
              >Support</a
            >
          </p>
        </li>
        <li id="idbacktodemigod2" *ngIf="showDemigod">
          <p class="navbar-text">
            <a
              (click)="backToDemigod()"
              style="cursor: pointer"
              title="This leads to demigod dashboard."
              class="navbar-link"
              >Back To Demigod</a
            >
          </p>
        </li>
      </ul>

      <div id="enplan-media">
        <div id="monkey-link-content"></div>
      </div>
    </div>
  </div>
</nav>

<nav
  *ngIf="!hideHeader && HideForEmbed !== 'true'"
  class="navbar navbar-default bluebar"
  [style.backgroundColor]="this.mapService.mapInterface.topbar_color"
>
  <div
    class="container-fluid"
    id="greenbar"
    [style.backgroundColor]="this.mapService.mapInterface.topbar_color"
  >
    <div class="navbar-header" *ngIf="!geoLockTool">
      <button
        type="button"
        class="navbar-toggle collapsed"
        data-toggle="collapse"
        data-target="#collapsable-nav"
        id="greenbar-toggle"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <p id="nav">
        <b class="mytooltip" style="margin-top: 12px"
          ><span
            *ngIf="mapService.elementsVisibility['name']"
            style="font-weight: 700; font-size: 13.5pt; font-family: Arial"
            >{{ mapName }}</span
          >
        </b>

        <span class="mytooltip">
          <span
            style="
              color: white;
              margin-left: 5px !important;
              font-family: arial !important;
            "
            *ngIf="mapService.elementsVisibility['subtitle']"
            >{{ sub }}
          </span>
        </span>
      </p>
    </div>
    <div class="collapse navbar-collapse" id="collapsable-nav">
      <span id="tools-back-icon"
        ><img src="/assets/img/tools/back-pv3.png" alt="back-icon"
      /></span>
      <span id="tools-collapse-expand" *ngIf="geoLockTool">
        <span class="tool-toolTip-expand" (click)="expandTool()">
          <img
            src="/assets/img/tools/expand-tools.png"
            [ngClass]="toolExpand ? 'showImage' : 'hideImage'"
          />

          <span class="tooltiptext-expand tip-bottom" id="expand_tooltip"
            ><strong>Expand Toolbar</strong></span
          ></span
        >

        <span
          class="tool-toolTip-expand"
          style="float: left"
          (click)="collapsedTool()"
        >
          <img
            src="/assets/img/tools/collapsed-tools.png"
            [ngClass]="toolCollapse ? 'showImage' : 'hideImage'"
          />

          <span class="tooltiptext-expand tip-bottom" id="collapse_tooltip"
            ><strong>Hide Toolbar</strong></span
          >
        </span>
      </span>
      <!----------------------------------------tools---------------------------------------------->
      <ul
        id="tools"
        class="tools nav navbar-nav navbar-left"
        *ngIf="!display && geoLockTool"
        [ngClass]="toolCollapse ? 'showImage' : 'hideImage'"
      >
        <ng-container *ngFor="let item of navItems">
          <ng-container *ngIf="item.display">
            <li
              [ngClass]="{ active: item.id === null }"
              (click)="
                item.id !== 3 && item.id !== 4 && item.id !== 16
                  ? toggleRightSidenav(item.id, item.displayName)
                  : null
              "
              (click)="
                item.id === 3 || item.id === 4 || item.id === 16
                  ? forwardBackward(item.id)
                  : setActive(item.id, 'customButton', item)
              "
              (click)="item.id === 16 ? reFresh() : null"
              class="active customButton"
              id="button-{{ item.id }}"
              (keypress)="onKeypressEvent($event)"
              (click)="
                item.id === 2 ? setActive(item.id, 'customButton', item) : null
              "
              (click)="item.id === 2 ? zoomBox() : null"
              class="active customButton"
              id="button-{{ item.id }}"
              (keypress)="onKeypressEvent($event)"
              (click)="
                item.id === 5 ? setActive(item.id, 'customButton', item) : null
              "
              (click)="item.id === 5 ? googleStreetView() : null"
              class="active customButton"
              id="button-{{ item.id }}"
              (keypress)="onKeypressEvent($event)"
            >
              <a
                id="layers-tool"
                class="tool-toolTip"
                [class.active]="toggleActive"
              >
                <!-- handling icon for forward and backward tool -->
                <img
                  *ngIf="
                    (item.id === 4 &&
                      forwardBackwardService?.index !==
                        forwardBackwardService?.stack?.length - 1) ||
                    (item.id === 3 && forwardBackwardService?.index !== 0) ||
                    (item.id !== 3 && item.id !== 4)
                  "
                  src="{{ item.iconName }}"
                />
                <img
                  *ngIf="item.id === 3 && forwardBackwardService?.index === 0"
                  src="/assets/img/tools/no-back-pv3.png"
                />
                <img
                  *ngIf="
                    item.id === 4 &&
                    forwardBackwardService?.index ===
                      forwardBackwardService?.stack?.length - 1
                  "
                  src="/assets/img/tools/no-forward-pv3.png"
                />
                <span
                  class="tooltiptext tip-bottom"
                  [innerHtml]="item.tooltip.description"
                ></span>
              </a>
            </li>
          </ng-container>
        </ng-container>
      </ul>
      <ul
        id="tools"
        class="tools nav navbar-nav navbar-left"
        *ngIf="!display && !geoLockTool"
      >
        <ng-container *ngFor="let item of navItems">
          <ng-container *ngIf="item.display">
            <li
              [ngClass]="{ active: item.id === null }"
              (click)="
                item.id !== 3 &&
                item.id !== 4 &&
                item.id !== 16 &&
                item.id !== 2 &&
                item.id !== 5
                  ? toggleRightSidenav(item.id, item.displayName)
                  : null
              "
              (click)="
                item.id === 3 ||
                item.id === 4 ||
                item.id === 16 ||
                item.id === 2 ||
                item.id === 5
                  ? forwardBackward(item.id)
                  : setActive(item.id, 'customButton', item)
              "
              (click)="item.id === 16 ? reFresh() : null"
              class="active customButton"
              id="button-{{ item.id }}"
              (keypress)="onKeypressEvent($event)"
              (click)="
                item.id === 2 ? setActive(item.id, 'customButton', item) : null
              "
              (click)="item.id === 2 ? zoomBox() : null"
              class="active customButton"
              id="button-{{ item.id }}"
              (keypress)="onKeypressEvent($event)"
              (click)="
                item.id === 5 ? setActive(item.id, 'customButton', item) : null
              "
              (click)="item.id === 5 ? googleStreetView() : null"
              class="active customButton"
              id="button-{{ item.id }}"
              (keypress)="onKeypressEvent($event)"
            >
              <a
                id="layers-tool"
                class="tool-toolTip"
                [class.active]="toggleActive"
              >
                <!-- handling icon for forward and backward tool -->
                <img
                  *ngIf="
                    (item.id === 4 &&
                      forwardBackwardService?.index !==
                        forwardBackwardService?.stack?.length - 1) ||
                    (item.id === 3 && forwardBackwardService?.index !== 0) ||
                    (item.id !== 3 && item.id !== 4)
                  "
                  src="{{ item.iconName }}"
                />
                <img
                  *ngIf="item.id === 3 && forwardBackwardService?.index === 0"
                  src="/assets/img/tools/no-back-pv3.png"
                />
                <img
                  *ngIf="
                    item.id === 4 &&
                    forwardBackwardService?.index ===
                      forwardBackwardService?.stack?.length - 1
                  "
                  src="/assets/img/tools/no-forward-pv3.png"
                />
                <span
                  class="tooltiptext tip-bottom"
                  [innerHtml]="item.tooltip.description"
                ></span>
              </a>
            </li>
          </ng-container>
        </ng-container>
        <div class="edit-icon" #editIcon>
          <li *ngIf="tools.geo_location && !isDesktop"   class="customButton ng-star-inserted " [ngClass]="{active: geoLocationActive}"><a
            id="layers-tool" class="tool-toolTip" [class.active]="toggleActive" [ngClass]="{active: geoLocationActive}">
            <img class="imageSearch" [class.hover-bg]="!geoLocationActive"  (click)="getGeoPosition()" src="/assets/img/location.png" alt="quick" />
            <span class="tooltiptext tip-bottom" [innerHtml]="toolTips.geo_location"></span>
          </a></li>
        </div>
      </ul>
      <span
        id="tools-back-icon"
        *ngIf="display"
        (click)="showTool()"
        style="display: inline"
        ><img src="/assets/img/tools/back-pv3.png" />
      </span>
      <!----------------------------------------right-elements---------------------------------------------->
      <div class="right-elements">
        <div *ngIf="showReports">
          <div class="report-close">
            <img
              class="report-close-img"
              (click)="myReports()"
              src="/assets/img/tools/close-pv3.png"
              width="20px"
            />
          </div>
          <ul class="submenu level_2">
            <ng-container *ngFor="let item of allUserReports; index as i">
              <li class="menu-list level_2">
                <div class="users-pro">
                  <label
                    id="download-map"
                    download
                    class="download"
                    (click)="downLoadFile(item.download_path)"
                    >{{ item.report_name }}</label
                  >
                  <a id="submit-pdf1" hidden download>{{ item.report_name }}</a>
                  <div class="price">
                    <label>{{ item.saved_at }}</label>
                  </div>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>

        <form
          id="quickform"
          class="navbar-form tools mytooltip tool-toolTip1"
          *ngIf="search"
        >
          <input id="search-options" type="hidden" />
          <div class="btn-group" id="quick-formgroup">
            <input placement="top" *ngIf="!display" (ngModelChange)="didModify($event)" (keyup.enter)="completeSearch()"
              id="quick-input" name="search" placeholder="Search..." class="ui-autocomplete-input search"
              autocomplete="off" style="padding-right: 25px" [(ngModel)]="searchValue" />
            <input *ngIf="display" (ngModelChange)="didModify($event)" (keyup.enter)="completeSearch()" placement="top"
              id="quick-input" name="search" placeholder="Search..." class="ui-autocomplete-input" autocomplete="off"
              style="padding-right: 25px" [(ngModel)]="searchValue" />
            <img *ngIf="loader && !panToZoomTool" id="mini-loading" src="/assets/img/wheel.svg" alt="wheel" />
            <img *ngIf="searchValue.length > 0 && showClose && display" id="search-close" class="search-close"
              src="/assets/img/tools/close-pv3.png" alt="close" (click)="clearSearch()" />
            <img *ngIf="searchValue.length > 0 && showClose" id="search-close" class="search-close clear-button"
              src="/assets/img/tools/close-pv3.png" alt="close" (click)="clearSearch()" />
            <input id="search-id" type="hidden" />
            <input id="layer-id" type="hidden" />
          </div>
          <a id="quick-tool" class="mytooltip search-tool2" placement="bottom">
            <img
              class="imageSearch"
              (click)="completeSearch()"
              src="/assets/img/tools/quick.png"
              alt="quick"
            />
            <span
              class="tooltiptext12 tip-bottom"
              [innerHtml]="mapService.templatetoolTips['search']"
            ></span>
          </a>
          <a id="quick-tool" class="mytooltip search-tool1" placement="bottom">
            <img
              (click)="hideTool(); completeSearch()"
              src="/assets/img/tools/quick.png"
              alt="quick"
            />
            <span
              class="tooltiptext12 tip-bottom"
              [innerHtml]="mapService.templatetoolTips['search']"
            ></span>
          </a>
          <br style="clear: both" />
        </form>
        <ul id="etctools" class="tools nav navbar-nav" *ngIf="!showFullScreenIcon && tools.coordinate_search">
          <li [ngClass]="[search ? 'help-tool' : 'help-to']">
            <a id="" class="" placement="bottom" (click)="panToZooom()">
              <img
                class="panToZoom"
                src="/assets/img/legend/map-to-zoom.png"
                alt="panZoom"
              />
            </a>
          </li>
        </ul>
        <ul id="etctools" class="tools nav navbar-nav" *ngIf="!showFullScreenIcon">
          <li [ngClass]="[search ? 'help-tool' : 'help-to',tools.coordinate_search ? 'help-tool' : 'pen-toZoom']">
            <a *ngIf="mapService.elementsVisibility['information_panel']"
              [ngClass]="activeInfo === true ? 'activeInfo' : ''" class="mytooltip tool-toolTip" (click)="info()">
              <img src="/assets/img/tools/help.png" alt="help" />
              <span
                class="tooltiptext tip-bottom tooltiptext1"
                [innerHtml]="mapService.templatetoolTips['help']"
              ></span
            ></a>
          </li>
        </ul>


        <ul id="etctools" class="tools nav navbar-nav" *ngIf="showFullScreenIcon">
          <li [ngClass]="[
              search
                ? 'help-tool-search'
                : 'help-to' || showFullScreenIcon
                ? 'help-to-embed'
                : 'help-tool'
            ]"
          >
            <a
              *ngIf="mapService.elementsVisibility['information_panel']"
              [ngClass]="activeInfo === true ? 'activeInfo' : ''"
              class="help-tool"
              class="mytooltip tool-toolTip"
              (click)="info()"
            >
              <img src="/assets/img/tools/help.png" alt="help" />
              <span
                class="tooltiptext tip-bottom tooltiptext1"
                [innerHtml]="mapService.templatetoolTips['help']"
              ></span
            ></a>
          </li>
        </ul>
        <ul
          id="etctools"
          class="tools nav navbar-nav"
          *ngIf="showFullScreenIcon"
        >
          <li>
            <a
              [ngClass]="[
                search ? 'full-screen-tool-search' : 'full-screen-tool'
              ]"
              class="mytooltip tool-toolTip"
              (click)="openEmbed()"
            >
              <img src="/assets/img/tools/fullscreen.png" alt="help" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
<ng-container *ngIf="!panToZoomTool">
  <app-uidrop-down-search
    [searchValue]="searchValue"
    [searchType]="searchType"
    (dataloaded)="loaded($event)"
    (doneSearch)="doneSearch()"
  ></app-uidrop-down-search>
</ng-container>
